export default __webpack_public_path__ + "static/media/icon-crypto.eb66b6f5.svg";